<template>
  <div class="icons">
    <v-tooltip
      v-for="icon in activeIcons"
      :key="icon.id"
      top
      :max-width="400"
      :color="icon.color || ''"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          class="icon-wrapper"
          @mousedown.stop
          @click.stop="icon.click ? icon.click() : null"
        >
          <component
            v-if="icon.type === 'component'"
            :is="icon.content"
            :width="icon.width || '22px'"
          />
          <img
            v-else-if="icon.type === 'image'"
            :src="icon.content"
            width="22"
            height="22"
            style="display: block"
          />
          <div
            v-else-if="icon.type === 'dot'"
            :class="['circle-dot', icon.content]"
          ></div>
        </div>
      </template>
      <span>{{ icon.tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import InfoCircleGreyIcon from '@/assets/icons/components/info-circle-grey.svg'
import InfoCircleRedIcon from '@/assets/icons/components/info-circle-red.svg'
import WarningIcon from '@/assets/icons/components/warning-icon.svg'
import VeganIcon from '@/assets/icons/components/vegan_icon.svg'
import GlutenIcon from '@/assets/icons/components/gluten_icon.svg'
import ProtocolIcon from '@/assets/icons/components/protocol_icon.svg'
import BloodIcon from '@/assets/icons/components/blood_icon.svg'

export default {
  name: 'SupplementIcons',
  components: {
    InfoCircleRedIcon,
    InfoCircleGreyIcon,
    WarningIcon,
    VeganIcon,
    GlutenIcon,
    ProtocolIcon,
    BloodIcon
  },
  props: {
    supplement: {
      type: Object,
      required: true
    }
  },
  computed: {
    activeIcons() {
      const s = this.supplement
      const icons = []

      if (!s) return []

      icons.push({
        id: 'info',
        type: 'component',
        content: s.isDuplicated ? 'InfoCircleRedIcon' : 'InfoCircleGreyIcon',
        tooltip: s.supplementDescription || s.description || '',
        click: () => this.$emit('show-crg-notes', s)
      })

      if (s.specialNotes) {
        icons.push({
          id: 'warning',
          type: 'component',
          content: 'WarningIcon',
          tooltip: s.specialNotes,
          click: () => this.$emit('warning-notes', s)
        })
      }
      if (s.brandLogo) {
        icons.push({ id: 'brand', type: 'image', content: s.brandLogo, tooltip: s.brandName })
      }
      if (s.vegetarian) {
        icons.push({ id: 'vegan', type: 'component', content: 'VeganIcon', tooltip: 'Vegetarian' })
      }
      if (s.glutenFree) {
        icons.push({ id: 'gluten', type: 'component', content: 'GlutenIcon', tooltip: 'Gluten Free' })
      }
      if (s.fromProtocol) {
        icons.push({ id: 'protocol', type: 'component', content: 'ProtocolIcon', tooltip: s.protocolName, color: '#F7936F' })
      }
      if (s.fromBlood) {
        icons.push({ id: 'blood', type: 'component', content: 'BloodIcon', tooltip: 'Blood', color: '#28605A' })
      }
      if (s.fromBloodPattern) {
        icons.push({ id: 'dot-pattern', type: 'dot', content: 'green', tooltip: 'Blood Pattern', color: '#499D66' })
      }
      if (s.fromBloodMarkerLab) {
        icons.push({ id: 'dot-marker', type: 'dot', content: 'dark-orange', tooltip: 'Blood Marker', color: '#F16063' })
      }
      if (s.fromBloodMarkerOptimal) {
        icons.push({ id: 'dot-optimal', type: 'dot', content: 'light-blue', tooltip: 'Blood Marker Optimal', color: '#00E0FF' })
      }

      return icons
    },
  }
}
</script>

<style lang="scss" scoped>
.icons {
  display: flex;
  align-items: center;
  gap: 6px;

  .icon-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .circle-dot {
    height: 8px;
    width: 8px;
    border-radius: 50%;

    &.green {
      background-color: #499D66;
    }

    &.dark-orange {
      background-color: #F16063;
    }

    &.light-blue {
      background-color: #00E0FF;
    }
  }
}
</style>
